<template>
  <div class="header" :style="[{ '--backgroundColor': headerBackground }]">
    <div class="headerBox">
      <a :href="hrefPath">
        <img class="logo" :src="headerType.logoSrc" />
      </a>
      <el-menu :default-active="activeIndex" class="menu-nav" mode="horizontal">
        <el-menu-item
          :index="item.value"
          v-for="(item, index) in menuList"
          :key="item.link"
          @click="onClick(item, index)"
        >
          <div class="nav-text">
            {{ item.name }}
          </div>
        </el-menu-item>
      </el-menu>
      <div>
        <div class="language">
          <GlobalLanguage></GlobalLanguage>
        </div>
        <img :src="hanburgerIcon" class="menu-hambuger" @click="openMenu" />
      </div>
    </div>
    <el-dialog
      :visible.sync="menuDialog"
      :before-close="handleClose"
      custom-class="menu-dialog"
      :modal="false"
    >
      <div slot="title" class="menu-title">
        <img class="menu-logo" :src="headerType.logoSrc" />
      </div>
      <el-menu :default-active="''" class="menu" mode="horizontal">
        <el-menu-item
          :index="item.link"
          v-for="(item, index) in menuList"
          :key="item.link"
          @click="onClick(item, index)"
        >
          {{ item.name }}
        </el-menu-item>
      </el-menu>
      <div class="copy-right">Copyright © 2022 desty. All rights reserved.</div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import GlobalLanguage from "./GlobalLanguage.vue";
import resetUrl from "../utils/resetUrl";

export default {
  props: ["showLogin", "showTop"],
  components: {
    // HeaderPrompt,
    // HeaderTop,
    GlobalLanguage,
  },
  data() {
    return {
      showLoginBox: false,
      showAppSwitcher: false,
      currentLanguage: "id",
      userMsg: null,
      storeOpen: false,
      menuDialog: false,
      showPrompt: false,
      hanburgerIcon: `${process.env.VUE_APP_STORE_OSS_URL}/home/hamburger.svg`,
      activeIndex: "2",
      headerBackground: "#effaff",
    };
  },
  computed: {
    ...mapState({
      deviceId: (state) => state.deviceId,
      trackParams: (state) => state.trackParams,
    }),
    hrefPath() {
      return process.env.VUE_APP_BASE_URL;
    },
    headerType() {
      return {
        logoSrc:
          "https://static.desty.app/desty-app/img/homepage/new-desty-logo.svg",
      };
    },
    pagePath() {
      return `${process.env.VUE_APP_PAGE_URL}`;
    },
    homePath() {
      return `${process.env.VUE_APP_BASE_URL}`;
    },
    marketPath() {
      return process.env.VUE_APP_MARKET_URL;
    },
    menuList() {
      return [
        { name: "Home", link: this.homePath, value: "0" },
        { name: "desty page", link: this.pagePath, value: "1" },
        { name: "desty store", link: "/", value: "2" },
        {
          name: "Market",
          link: this.marketPath,
          value: "6",
        },
        {
          name: "Blog",
          link: "https://desty.page/blog",
          value: "3",
        },
        {
          name: this.$t("header.career"),
          link: "https://desty.freshteam.com/jobs",
          value: "4",
        },
        {
          name: this.$t("header.help"),
          link: "https://desty.tawk.help/",
          value: "5",
        },
      ];
    },
  },
  methods: {
    onClick(path) {
      if (this.$route.path !== path.link) {
        path.link = resetUrl(path.link, this.trackParams);
        if (path.value === "2") {
          this.$router.push(path.link);
        } else if (
          path.value === "0" ||
          path.value === "1" ||
          path.value === "6"
        ) {
          window.open(`${path.link}`, "_self");
        } else {
          window.open(`${path.link}`, "_blank");
        }
      }
    },
    openMenu() {
      this.menuDialog = true;
      this.$emit("closeSubHeader");
    },
    handleClose() {
      this.menuDialog = false;
    },
    handleHeaderTop() {
      this.$emit("handleHeaderTop");
    },
  },
  beforeCreate() {
    const { utm_content, utm_source, utm_medium, utm_campaign, utm_term } =
      this.$route.query;
    this.utm_content = utm_content;
    this.utm_source = utm_source;
    this.utm_medium = utm_medium;
    this.utm_campaign = utm_campaign;
    this.utm_term = utm_term;

    this.url = process.env.VUE_APP_BASE_URL;
  },
  async mounted() {
    this.$i18n.locale = this.$store.state.language;
    if (window.gapi) {
      window.gapi.load("auth2", function google() {
        window.gapi.auth2.init({
          scope: "profile email",
          prompt: "select_account",
        });
      });
    }
  },
  watch: {
    $route: {
      handler(val) {
        if (val.name === "Templates") {
          this.headerBackground = "#ccefff";
        } else {
          this.headerBackground = "#effaff";
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  // width: calc(100% - 312px);
  padding: 0 106px 109px;
  box-sizing: border-box;
  position: relative;
  // width: 100%;
  background: var(--backgroundColor);
  .headerBox {
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: var(--backgroundColor);
    border-bottom: 1px solid #000000;
  }
  .language {
    position: absolute;
    right: 106px;
    top: 33px;
    display: flex;
  }
  .logo {
    width: 72px;
    height: 30px;
    vertical-align: middle;
  }
  .menu-hambuger {
    width: 28px;
    height: 16px;
    display: none;
  }
  /deep/.menu-nav {
    border-bottom: none;
    margin-left: 189px;
    .el-menu--horizontal > .el-menu-item {
      height: 100px;
    }
    .el-menu-item {
      color: rgba(0, 0, 0, 0.5);
      font-family: @font-family-regular;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 18px;
      border-bottom: none;
      display: flex;
      flex-direction: row;
      align-items: center;
      letter-spacing: -0.02em;
      background: var(--backgroundColor);
    }
    .el-menu-item.is-active {
      color: #000;
    }
    .nav-text {
      position: relative;
    }
    .nav-text.is-active {
      // text-decoration-line: underline;
      color: #000;
      background-color: var(--backgroundColor) !important;
    }
    .el-menu-item:not(.is-disabled):focus {
      background-color: var(--backgroundColor) !important;
    }
    .el-menu-item.is-active .nav-text::after {
      width: 100%;
    }
    .el-menu-item:hover {
      color: #000;
      background-color: var(--backgroundColor) !important;
    }
    .nav-text::after {
      content: "";
      display: block;
      /*开始时候下划线的宽度为0*/
      width: 0;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: -10px;
      background: #000;
      /*这里我们设定所有改变都有动画效果，可以自己指定样式才有动画效果*/
      transition: all 0.3s ease-in-out;
    }
    .nav-text:hover::after {
      width: 100%;
    }
  }
  @media screen and (max-width: 1174px) {
    padding: 0 15px 76px;
    box-sizing: border-box;
    .headerBox {
      height: 67px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .language {
      top: auto;
      right: 68px;
    }
    .logo {
      width: 64px;
    }
    .menu-nav {
      display: none;
      .el-menu--horizontal > .el-menu-item {
        height: 67px;
      }
    }
    .menu-hambuger {
      display: block;
    }
  }
}
.header-color {
  background: #ccefff !important;
}
/deep/.menu-dialog {
  width: 100%;
  height: 100%;
  margin-top: 0 !important;
  background: #ffffff;
  backdrop-filter: blur(6px);
  .el-dialog__header {
    padding: 12px 15px;
    box-sizing: border-box;
    display: flex;
  }
  .el-dialog__body {
    padding: 106px 15px 0;
    box-sizing: border-box;
    .el-menu {
      // background: transparent;
    }
    .menu {
      display: flex;
      flex-direction: column;
      border-bottom: none;
      .el-menu-item {
        border-bottom: none;
        font-family: @font-family-regular;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 40px;
        height: 40px;
        padding: 0px;
        margin-bottom: 20px;
        letter-spacing: -0.04em;
        color: #000000;
        opacity: 0.5;
        width: min-content;
      }
      .el-menu-item.is-active {
        color: #000000;
        opacity: 1;
      }
      .el-menu-item.is-active::after {
        width: 100%;
      }
      .el-menu-item:hover {
        // text-decoration-line: underline;
        color: #000;
        background-color: var(--backgroundColor) !important;
        opacity: 1;
      }
      .el-menu-item::after {
        content: "";
        display: block;
        /*开始时候下划线的宽度为0*/
        width: 0;
        height: 1px;
        position: absolute;
        left: 0;
        bottom: -10px;
        background: #000;
        /*这里我们设定所有改变都有动画效果，可以自己指定样式才有动画效果*/
        transition: all 0.3s ease-in-out;
      }
      .el-menu-item:hover::after {
        width: 100%;
      }
    }
    .copy-right {
      font-family: @font-family-regular;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      color: #000000;
      opacity: 0.5;
      padding: 0 11px;
      box-sizing: border-box;
      position: fixed;
      bottom: 60px;
    }
  }
  .menu-title {
    .menu-logo {
      width: 64px;
    }
  }
  .el-dialog__headerbtn {
    top: 12px;
    .el-dialog__close {
      color: #1b2666;
      font-size: 24px;
    }
  }
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent;
}
</style>
